import { useEffect, useState } from 'react';
import type { BankAccount } from '@api/btlApplicationForm/types';
import { BankDetailsEmptyState } from './BankDetailsEmptyState';
import { BankDetailsForm } from './BankDetailsForm';

export interface IBankDetailsPageProps {
  applicationId: string;
  bankAccount?: BankAccount;
  isLoading?: boolean;
  openInEditMode?: boolean;
  onOpenInEditModeConsumed?: () => void;
}

function hasBankDetails(bankAccount?: BankAccount): boolean {
  return Boolean(bankAccount?.accountName);
}

export function BankDetailsPage({
  applicationId,
  bankAccount,
  isLoading,
  openInEditMode,
  onOpenInEditModeConsumed,
}: IBankDetailsPageProps) {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!openInEditMode) {
      return;
    }

    setIsEditing(true);
    onOpenInEditModeConsumed?.();
  }, [openInEditMode, onOpenInEditModeConsumed]);

  if (isLoading) {
    return null;
  }

  if (isEditing) {
    return (
      <BankDetailsForm
        applicationId={applicationId}
        bankAccount={bankAccount}
        onCancel={() => setIsEditing(false)}
        onSaved={() => setIsEditing(false)}
      />
    );
  }

  if (hasBankDetails(bankAccount) && bankAccount) {
    return <BankDetailsForm applicationId={applicationId} bankAccount={bankAccount} readOnly />;
  }

  return <BankDetailsEmptyState onAdd={() => setIsEditing(true)} />;
}
